// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","activeColor":"#7cf4fe","defaultColor":"#9CCEF9","uiBlack":"#000000","screen-min":"639px","screen-xs-max":"1023px","screen-sm-max":"1365px"};